import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import btnarw_white from "../assets/images/btnarw_white.svg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import fixed from "../assets/images/fixed.svg";
import timed from "../assets/images/timed.svg";
import $ from "jquery";
import info from "../assets/images/info.svg";
import collectionABI from "../ABI/CollectionABI.json";
import HashLoader from "react-spinners/HashLoader";
import Web3 from "web3";
import { toastAlert } from "../lib/toastAlert";
import { getCategory } from "../actions/nfts";
import { createCollection, uploadIPFSDir, nftNameCheck } from "../actions/nfts";
import config from "../lib/config";
import { Numberconvert } from "../helper/numberConvert.js";
import { useSelector } from "react-redux";

const override = {
  // display: "block",
  // margin: "0 auto",
  borderColor: "red",
  position: "fixed",
  top: "50%",
  left: "50%",
  marginLeft: "-32px",
  marginTop: "-32px",
  zIndex: "99999"
};

const CollectionSchema = Yup.object().shape({
  collName: Yup.string()
    .required("Required")
    .test("value", "Required", (value) => value.trim().length != 0)

    .matches(
      /^([a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð '])+$/u,
      "Insert only normal character"
    ),
  collSymb: Yup.string()
    .required("Required")
    .test("value", "Required", (value) => value.trim().length != 0),
  logoImg: Yup.mixed()
    .required("Required")
    .test("fileType", "Unsupported file type", (value) => {
      if (!value) return false;
      const supportedTypes = ["image/jpeg", "image/png", "image/gif"];
      return supportedTypes.includes(value.type);
    }),
  nftsImgs: Yup.mixed().required("Required"),

  // collPrice: Yup.number()
  //   .required("Required")
  //   .typeError("Value must specify a number")
  //   .moreThan(0, "Value must be greater than 0"),
  collRoyalty: Yup.number()
    .required("Required")
    .min(5, "Value must be greater than or equal to 5")
    .max(40, "Value must be less than or equal to 40")
    .typeError("Value must specify a number (within 5 to 40)"),
  // collNft: Yup.string()
  //   .required("Required")
  //   .matches(
  //     /^([0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð '])+$/u,
  //     "Number value only allowed"
  //   ),
  Collcate: Yup.string().required("Required"),
  collSymb: Yup.string()
    .required("Required")
    .test("value", "Required", (value) => value.trim().length != 0)

    .matches(
      /^([a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð '])+$/u,
      "Insert only normal character"
    ),
  shortUrl: Yup.string()
    .required("Required")
    .test("value", "Required", (value) => value.trim().length != 0)

    .matches(
      /^([a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð '])+$/u,
      "Insert only normal character"
    )
});

export default function Create_collection() {
  const walletConnection = useSelector((state) => state.walletConnection);
  let [loading, setLoading] = useState(false);
  const [fileSet, setFileSet] = useState([]);
  const [PreviewImg, setPreviewImg] = useState([]);
  const [preUrl, setPreUrl] = useState();
  const [PreviewImgBnr, setPreviewImgBnr] = useState();
  const [bannerImg, setBannerImg] = useState("");
  const [fileVali, setFileVali] = useState("");
  const [swapEnable, setSwapEnable] = useState(false);
  const [Unlockoncepurchased, setUnlockoncepurchased] = useState(false);
  const [saleType, setSaleType] = useState("");
  const [categoryList, setCategoryList] = useState([]);

  // const handleChanage = (e) => {
  //   const files = e.target.files;
  //   let images = [];
  //   for (let i = 0; i < e.target.files.length; i++) {
  //     images.push(URL.createObjectURL(e.target.files[i]));
  //   }

  //   console.log(files, "Files");
  //   setPreviewImg(images);
  //   setFileSet([...files]);
  // };

  useEffect(() => {
    getCategorylist();
  }, []);

  const getCategorylist = async () => {
    const result = await getCategory();

    console.log(result, "category");
    if (result.data.status) {
      setCategoryList(result.data.data);
    } else {
      setCategoryList([]);
    }
  };
  // const handleChanageBnr = (e) => {
  //   const file = URL.createObjectURL(e.target.files[0]);
  //   setPreviewImgBnr(file);
  //   setBannerImg(e.target.files[0]);
  // };

  const CheckedChange = (e) => {
    if (e.target.name == "Swap") {
      if (swapEnable == false) {
        setSwapEnable(true);
      } else {
        setSwapEnable(false);
      }
    }
  };

  const handleSaleTypeChange = (e) => {
    setSaleType(e.target.value);
  };
  async function ChecktokenDecimal(amount, decimals) {
    var result = 0;
    var decimalsLength = 18;
    if (decimals && decimals > 0) {
      decimalsLength = decimals;
    }
    try {
      var number = amount.toString();
      var number1 = number.split(".");
      if (number1[1] && number1[1].length && number1[1].length > 0) {
        result = number1[0];
      } else {
        result = amount;
      }
      return result;
    } catch (err) {
      return result;
    }
  }

  console.log(fileSet, "fileSetfileSetfileSet");
  console.log(PreviewImg, "PreviewImgPreviewImgPreviewImg");
  return (
    <div>
      <Navbar />
      <div className="page_box">
        <div className="create_nft create_collection">
          <div className="container">
            <div className="row">
              <Formik
                initialValues={{
                  collName: "",
                  collDisc: "",
                  collSymb: "",
                  collPrice: "",
                  collRoyalty: "",
                  collNft: "",
                  shortUrl: "",
                  Collcate: "",
                  logoImg: "",
                  nftsImgs: ""
                }}
                validationSchema={CollectionSchema}
                onSubmit={async ({
                  collName,
                  collSymb,
                  collDisc,
                  collPrice,
                  collRoyalty,
                  collNft,
                  shortUrl,
                  Collcate,
                  logoImg,
                  nftsImgs
                }) => {
                  console.log(nftsImgs, "nftsImgs");
                  if (!walletConnection.address) {
                    toastAlert("error", "Connect Wallet");
                    return false;
                  }
                  if (!window.ethereum) {
                    toastAlert("error", "Install Metamask");
                    return false;
                  }
                  console.log(fileSet, "Filrwwew");
                  if (fileSet.length == 0) {
                    console.log("Ceheck");
                    setFileVali("Required");
                    return false;
                  }
                  if (bannerImg == "") {
                    console.log("Ceheck");
                    setFileVali("Required");
                    return false;
                  }
                  setLoading(true);

                  const nameCheckpay = {
                    collName,
                    flog: 1,
                    address: walletConnection.address
                  };
                  const dataCheck = await nftNameCheck(nameCheckpay);
                  console.log(dataCheck, "dataCheck");
                  if (dataCheck?.data?.status == false) {
                    toastAlert("error", dataCheck?.data?.message);
                    setLoading(false);
                    return false;
                  }

                  console.log(collPrice, "collPrice");

                  var web3 = new Web3(window.ethereum);
                  console.log(web3, "web3web3");
                  if (window.web3.currentProvider.isMetaMask === false) {
                    toastAlert("error", "Install Metamask");
                    return false;
                  }

                  let DigitPrice = Number(collPrice) * config.decimalValues;
                  let DecimalCheck = await ChecktokenDecimal(DigitPrice);
                  let ConverValue = await Numberconvert(DecimalCheck);
                  // let collRoyalty1 = await Numberconvert(collRoyalty);
                  console.log(walletConnection.address, "efedfefefef");
                  // var result = await web3.eth.getAccounts();
                  var currAddr = walletConnection.address;
                  let jsonABI = collectionABI;
                  let byteCode =
                    "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";
                  const collPayload = {
                    arguments: [
                      config.tokenContract,
                      config.SingleNFT,
                      collName,
                      collSymb,
                      collRoyalty,
                      fileSet.length
                    ]
                  };
                  console.log(
                    collPayload,
                    "collPayload",
                    typeof fileSet,
                    fileSet.length
                  );
                  let contractDeploy = await new web3.eth.Contract(jsonABI);
                  console.log(contractDeploy, "contractDeploy");
                  contractDeploy.options.data = "0x" + byteCode;
                  let HashValue;
                  let account = currAddr;
                  let parameter = {
                    from: account
                  };
                  await contractDeploy
                    .deploy(collPayload)
                    .send(parameter, (err, transactionHash) => {
                      HashValue = transactionHash;
                    })
                    .on("confirmation", () => {})
                    .then(async (newContractIns) => {
                      let Bep20 = newContractIns.options.address;
                      console.log(newContractIns, Bep20, "newContractIns");
                      // setContractAddrUser(Bep20);

                      if (swapEnable) {
                        const NFTCollContract = new web3.eth.Contract(
                          collectionABI,
                          Bep20
                        );
                        await NFTCollContract.methods
                          .setApprovalForAll(config.swapContract, true)
                          .send({ from: currAddr })
                          .then(async (data) => {})
                          .catch((err) => console.log(err));
                      }
                      const payload = {
                        collName,
                        collDisc,
                        collPrice,
                        collRoyalty,
                        image: fileSet,
                        ownerAddr: account,
                        Collcate
                      };
                      console.log(payload, "CheckPay");
                      const data = await createCollection(payload);
                      console.log(data, "fefefefefe");
                      if (data.data.status == true) {
                        setTimeout(async () => {
                          console.log("Pinat Flow");
                          const payload = {
                            Image: bannerImg,
                            folder: data.data.data,
                            files: data.data.files,
                            userAddr: currAddr,
                            newContract: Bep20,
                            collName,
                            collSymb,
                            collDisc,
                            collPrice,
                            collRoyalty,
                            Collcate,
                            collNft,
                            ownerAddr: account,
                            Unlockoncepurchased: Unlockoncepurchased,
                            url: config.frontUrl + "/" + shortUrl,
                            swapEnable: swapEnable,
                            HashValue: HashValue
                          };
                          console.log(payload, "Paydf-");
                          const dataUpload = await uploadIPFSDir(payload);
                          console.log(dataUpload, "dataUpload");
                          if (dataUpload.data?.data?.status == true) {
                            console.log(dataUpload.data, "afcsefcesfefe");
                            toastAlert(
                              "success",
                              "Collection Created Successfully"
                            );
                            setTimeout(() => {
                              window.location.href = "/explore";
                              setLoading(false);
                            }, 1000);
                          }
                        }, 10500);
                      }
                    })
                    .catch((err) => {
                      console.log(err, "===========eeeeeeee");
                      setLoading(false);
                      toastAlert("error", "User Rejected Transaction");
                    });
                }}
              >
                {({ errors, touched }) => (
                  <div className="col-lg-9 mx-auto">
                    <div className="row">
                      <Form>
                        <div className="col-md-7 mx-auto ">
                          <h2 className="h2tag mb-2">
                            Create Your New Collection{" "}
                          </h2>
                          <p className="para pb-5">MATIC - ERC-721</p>
                          <div className="mb-4">
                            <label
                              for="exampleInputEmail1"
                              className="form-label"
                            >
                              Upload Items<span className="star">*</span>
                            </label>
                            <p>Image, Video or Audio.</p>
                            <p>
                              File types supported: PNG, JPEG, GIF, MP4, MP3,
                              SVG, WEBP, WEBM.
                            </p>
                            <p className="mb-3">Maximum file size: 100mb</p>
                            <Field name="nftsImgs">
                              {({ field, form }) => (
                                <>
                                  <div className="choose_box">
                                    <input
                                      type="file"
                                      className="form-control"
                                      id="fileupload"
                                      onChange={(e) => {
                                        const files = e.target.files;
                                        if (e.target.files.length > 0) {
                                          form.setFieldValue("nftsImgs", files);
                                          if (fileSet.length > 0) {
                                            let images = [];
                                            let preUrl1 = [];
                                            for (
                                              let i = 0;
                                              i < e.target.files.length;
                                              i++
                                            ) {
                                              console.log(
                                                e.target.files[i].name,
                                                "ewffewf"
                                              );
                                              preUrl1.push(
                                                e.target.files[i].name
                                              );
                                              images.push(
                                                URL.createObjectURL(
                                                  e.target.files[i]
                                                )
                                              );
                                            }

                                            console.log(files, "Files");
                                            setPreviewImg([
                                              ...PreviewImg,
                                              ...images
                                            ]);
                                            setPreUrl([...preUrl, ...preUrl1]);
                                            setFileSet([...fileSet, ...files]);
                                          } else {
                                            let images = [];
                                            let preUrl = [];
                                            for (
                                              let i = 0;
                                              i < e.target.files.length;
                                              i++
                                            ) {
                                              console.log(
                                                e.target.files[i].name,
                                                "ewffewf"
                                              );
                                              preUrl.push(
                                                e.target.files[i].name
                                              );
                                              images.push(
                                                URL.createObjectURL(
                                                  e.target.files[i]
                                                )
                                              );
                                            }

                                            console.log(files, "Files");
                                            setPreviewImg(images);
                                            setPreUrl(preUrl);
                                            setFileSet([...files]);
                                          }
                                        }
                                      }}
                                      multiple
                                      accept=".jpg, .jpeg, .png, .gif, .mp3, .mp4, .svg, .webp, .webm"
                                    />
                                    <span className="dark">Bulk upload</span>
                                  </div>

                                  {errors.nftsImgs && touched.nftsImgs ? (
                                    <span className="error-msg">
                                      {errors.nftsImgs}
                                    </span>
                                  ) : null}
                                </>
                              )}
                            </Field>
                          </div>

                          <div className="PreviewsImage">
                            {fileSet == "" ? (
                              ""
                            ) : (
                              <>
                                {PreviewImg.map((ele, i) => {
                                  return (
                                    <>
                                      {preUrl[i].split(".").pop() == "mp4" ? (
                                        <li className="imageGrid" key={i}>
                                          <video
                                            width="100"
                                            height="100"
                                            type="video/mp4"
                                            id="get_file_2"
                                            class="lazy nft__item_preview"
                                            autoPlay
                                            playsInLine
                                            loop
                                            muted
                                            src={ele}
                                          />
                                        </li>
                                      ) : preUrl[i].split(".").pop() ==
                                        "mp3" ? (
                                        <li className="imageGrid" key={i}>
                                          <audio
                                            width="40"
                                            height="100"
                                            style={{ width: "100px" }}
                                            type="audio/mp3"
                                            controls
                                            controlsList="nodownload"
                                            src={ele}
                                          />
                                        </li>
                                      ) : (
                                        <li className="imageGrid" key={i}>
                                          <img
                                            width="100"
                                            height="100"
                                            src={ele}
                                          />
                                        </li>
                                      )}
                                    </>
                                  );
                                })}
                              </>
                            )}
                          </div>

                          <div className="mb-4">
                            <label
                              for="exampleInputEmail1"
                              className="form-label"
                            >
                              Upload logo <span className="star">*</span>
                            </label>
                            <p>File types supported: PNG, JPEG, JPG or GIF.</p>
                            <p className="mb-3">Maximum file size: 100mb</p>
                            <Field name="logoImg">
                              {({ field, form }) => (
                                <>
                                  <div className="choose_box">
                                    <input
                                      type="file"
                                      className="form-control"
                                      accept="jpg, .jpeg, .png, .gif"
                                      onChange={(e) => {
                                        var validExtensions = [
                                          "jpg",
                                          "png",
                                          "gif",
                                          "jpeg"
                                        ];
                                        var filee = e.target.files[0];
                                        var fileName = filee.name;
                                        var fileNameExt = fileName.substr(
                                          fileName.lastIndexOf(".") + 1
                                        );
                                        if (
                                          $.inArray(
                                            fileNameExt,
                                            validExtensions
                                          ) == -1
                                        ) {
                                          toastAlert(
                                            "error",
                                            "Only these file types are accepted : " +
                                              validExtensions.join(", ")
                                          );
                                          $("input[name='logoImg']").val("");
                                          return false;
                                        }
                                        const file = URL.createObjectURL(
                                          e.target.files[0]
                                        );
                                        setPreviewImgBnr(file);
                                        setBannerImg(e.target.files[0]);
                                        form.setFieldValue(
                                          "logoImg",
                                          e.target.files[0]
                                        );
                                      }}
                                    />
                                    <span>Choose file</span>
                                  </div>
                                  {errors.logoImg && touched.logoImg ? (
                                    <span className="error-msg">
                                      {errors.logoImg}
                                    </span>
                                  ) : null}
                                </>
                              )}
                            </Field>
                          </div>

                          <div className="PreviewsImage mb-4">
                            {PreviewImgBnr ? (
                              <img
                                width="100"
                                height="100"
                                src={PreviewImgBnr}
                              />
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="mb-4">
                            <label
                              for="exampleInputEmail1"
                              className="form-label"
                            >
                              Display Name<span className="star">*</span>
                            </label>
                            <p className="mb-3">
                              Collection (Token) name cannot be changed in the
                              future
                            </p>
                            <Field
                              type="text"
                              className="form-control"
                              name="collName"
                              placeholder="e.g John Smith"
                            />
                            {errors.collName && touched.collName ? (
                              <span className="error-msg">
                                {errors.collName}
                              </span>
                            ) : null}
                          </div>

                          <div className="mb-4 pb-1">
                            <label
                              for="exampleInputEmail1"
                              className="form-label"
                            >
                              Description
                              <span className="small">(optional)</span>
                            </label>
                            <p className="mb-3">
                              The description provided will be included on the
                              collection’s page, underneath its image.
                            </p>
                            <div className="form-floating">
                              <Field
                                id="floatingTextarea2"
                                name="collDisc"
                                render={({ field, form: { isSubmitting } }) => (
                                  <textarea
                                    {...field}
                                    className="textbox"
                                    placeholder="Provide a detailed description of your item"
                                  />
                                )}
                              />
                            </div>
                          </div>

                          <div className="mb-4">
                            <label
                              for="exampleInputEmail1"
                              className="form-label"
                            >
                              Symbol<span className="star">*</span>
                            </label>
                            <p className="mb-3">
                              Collection symbol cannot be changed in the future
                            </p>
                            <Field
                              type="text"
                              className="form-control"
                              name="collSymb"
                              placeholder="enter symbol"
                            />
                            {errors.collSymb && touched.collSymb ? (
                              <span className="error-msg">
                                {errors.collSymb}
                              </span>
                            ) : null}
                          </div>
                          <div className="mb-4">
                            <label
                              for="exampleInputEmail1"
                              className="form-label"
                            >
                              Category<span className="star">*</span>
                            </label>
                            <p className="mb-3">
                              Collection Category cannot be changed in the
                              future
                            </p>
                            <Field
                              type="text"
                              className="form-control"
                              name="Collcate"
                              placeholder="enter token symbol"
                              as="select"
                            >
                              <option value="">Select Category</option>
                              {categoryList.map((ele) => {
                                return (
                                  <option value={ele.Category}>
                                    {ele.Category}
                                  </option>
                                );
                              })}
                            </Field>
                            {errors.Collcate && touched.Collcate ? (
                              <span className="error-msg">
                                {errors.Collcate}
                              </span>
                            ) : null}
                          </div>

                          <div className="mb-4">
                            <label
                              for="exampleInputEmail1"
                              className="form-label"
                            >
                              Short URL
                            </label>
                            <p className="mb-3">
                              This URL will be used as public URL
                            </p>
                            <div className="input_textbox">
                              <span className="input_text">
                                {config.baseUrl}/coll/
                              </span>
                              <Field
                                type="text"
                                name="shortUrl"
                                className="form-control"
                                placeholder="Enter your preferred URL"
                              />
                              {errors.shortUrl && touched.shortUrl ? (
                                <span className="error-msg">
                                  {errors.shortUrl}
                                </span>
                              ) : null}
                            </div>
                          </div>

                          {/* <div className="create_nftbox mb-4">
                            <div className="flx">
                              <div className="flx_box ms-0">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="saleType"
                                    value={"TimedAuction"}
                                    onChange={handleSaleTypeChange}
                                    id="flexRadioDefault1"
                                    defaultChecked
                                  />

                                  <label
                                    className="form-check-label"
                                    for="flexRadioDefault1"
                                  >
                                    <img
                                      src={fixed}
                                      alt="img"
                                      className="img-fluid mb-3"
                                    />
                                    <span> Fixed price</span>
                                  </label>
                                </div>
                              </div>
                              <div className="flx_box me-0">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="saleType"
                                    value={"FixedPrice"}
                                    onChange={handleSaleTypeChange}
                                    id="flexRadioDefault2"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="flexRadioDefault2"
                                  >
                                    <img
                                      src={timed}
                                      alt="img"
                                      className="img-fluid mb-3"
                                    />
                                    <span>Time auctioned</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div> */}

                          {/* <div className="mb-4">
                            <label
                              for="exampleInputEmail1"
                              className="form-label"
                            >
                              Price<span className="star">*</span>
                            </label>
                            <div className="input-group mb-3">
                              <Field
                                type="text"
                                className="form-control"
                                name="collPrice"
                              />
                              <span
                                className="input-group-text"
                                id="basic-addon2"
                              >
                                ETH
                              </span>

                              {errors.collPrice && touched.collPrice ? (
                                <span className="error-msg">
                                  {errors.collPrice}
                                </span>
                              ) : null}
                            </div>
                          </div> */}

                          <div className="mb-4">
                            <label
                              for="exampleInputEmail1"
                              className="form-label"
                            >
                              Royalties
                            </label>
                            <div className="input-group mb-3">
                              <Field
                                type="text"
                                className="form-control"
                                name="collRoyalty"
                                placeholder="Suggested 5% (Max 40%)"
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-", ",", " ", "."].includes(
                                    evt.key
                                  ) && evt.preventDefault()
                                }
                              />

                              <span
                                className="input-group-text"
                                id="basic-addon2"
                              >
                                %
                              </span>
                            </div>
                            {errors.collRoyalty && touched.collRoyalty ? (
                              <span className="error-msg">
                                {errors.collRoyalty}
                              </span>
                            ) : null}
                          </div>

                          <div className="mb-4">
                            <div className="form-check form-switch">
                              <p>
                                Make it available for swap
                                <span
                                  class="d-inline-block"
                                  tabindex="0"
                                  data-bs-toggle="tooltip"
                                  title="Make it available for swap"
                                >
                                  <img
                                    src={info}
                                    alt="img"
                                    className="ms-2 img-fluid"
                                    style={{ cursor: "pointer" }}
                                  />
                                </span>
                              </p>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="Swap"
                                role="switch"
                                onChange={CheckedChange}
                                id="flexSwitchCheckDefault"
                              />
                            </div>
                          </div>
                          {localStorage.getItem("nicholousWallAddr") ? (
                            <button
                              type="submit"
                              className="primary_btn dark w-100 "
                            >
                              Create Collection
                              <img
                                src={btnarw_white}
                                alt="img"
                                className="ms-3 img-fluid"
                              />
                            </button>
                          ) : (
                            <button
                              // type="submit"
                              className="primary_btn dark w-100 "
                              disabled={true}
                            >
                              Please connect wallet
                              <img
                                src={btnarw_white}
                                alt="img"
                                className="ms-3 img-fluid"
                              />
                            </button>
                          )}
                        </div>
                      </Form>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>

        <div className="wizard-progress">
          <div className="step complete">
            <div>
              <div className="node"></div> Choose blockchain
            </div>
          </div>
          <div className="step complete">
            Choose Type
            <div className="node"></div>
          </div>
          <div className="step">
            Create Collection
            <div className="node"></div>
          </div>
        </div>
      </div>
      {loading && (
        <div className="loadBefore">
          <HashLoader
            color={"#9a55ff"}
            loading={loading}
            cssOverride={override}
            size={60}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}
    </div>
  );
}
